var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "fullSize" },
    [
      _vm.initialLoad && (_vm.loadingAlertTypes || _vm.loadingAlertStatistics)
        ? _c("loading-page")
        : _vm.isUserNoAlertCards || _vm.isAdminNoAlertTypes
        ? _c("default-page", {
            attrs: {
              imageUrl: "/img/dynamic-src-images/trade-watcher.svg",
              title: _vm.$options.name,
              text: _vm.emptyPageStateText,
              buttonText: "Get Started",
              noButtons: _vm.isUserNoAlertCards && !_vm.alertTypes.length,
            },
            on: {
              "button-clicked": function ($event) {
                _vm.isUserNoAlertCards
                  ? _vm.createAlert()
                  : _vm.getAlertTypes(true, true)
              },
            },
          })
        : _c(
            "v-container",
            {
              staticClass: "pt-0 px-0",
              class: _vm.$vuetify.breakpoint.smAndDown
                ? "fix-overlays"
                : "supplementary-class",
              style: `width: 100%;height:${_vm.windowSizeY - 88}px !important;`,
              attrs: { fluid: "" },
            },
            [
              _vm.isNotDesktop
                ? _c("div", { staticClass: "navDraw-helper" })
                : _vm._e(),
              _c("confirm-dialog", {
                attrs: {
                  dialog: _vm.confirmDialog,
                  text: _vm.confirmationDialogText,
                  acceptButton: "Delete",
                },
                on: {
                  "confirmation-event": _vm.confirmationDialogEvent,
                  "mutate-confirm-dialog": (value) =>
                    (this.confirmDialog = value),
                },
              }),
              _vm.$vuetify.breakpoint.mdAndUp
                ? _c(
                    "div",
                    {
                      class: {
                        "tw-btn-container-left":
                          _vm.$vuetify.breakpoint.mdAndUp,
                        "tw-btn-container-left-mobile":
                          _vm.$vuetify.breakpoint.smAndDown,
                      },
                    },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "open-on-hover": !_vm.isNotDesktop,
                            "offset-y": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showHistory,
                                              expression: "showHistory",
                                            },
                                          ],
                                          class: {
                                            "primary--text":
                                              _vm.historyFilter !== "all",
                                          },
                                          staticStyle: { "margin-top": "2px" },
                                          attrs: { icon: "", small: "" },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                            },
                                          },
                                          [_vm._v("fas fa-filter")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1662547939
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "py-0", attrs: { dense: "" } },
                            [
                              _c(
                                "v-subheader",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [_vm._v(" Filter ")]
                              ),
                              _vm._l(_vm.filters, function (filterItem) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: `filter-option-${filterItem.value}`,
                                    staticClass: "accent",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeHistoryFilter(
                                          filterItem.value
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-action",
                                      { staticClass: "ma-0" },
                                      [
                                        filterItem.value === "all"
                                          ? _c(
                                              "v-icon",
                                              {
                                                class: {
                                                  "primary--text":
                                                    _vm.historyFilter === "all",
                                                },
                                                staticStyle: {
                                                  "font-size": "14px",
                                                },
                                              },
                                              [_vm._v("fas fa-th ")]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                class: {
                                                  "primary--text":
                                                    filterItem.checked === true,
                                                },
                                                staticStyle: {
                                                  "font-size": "14px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      !!filterItem.checked
                                                        ? "far fa-check-circle"
                                                        : "far fa-circle"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-title",
                                      {
                                        class: {
                                          "primary--text": !!filterItem.checked,
                                        },
                                      },
                                      [_vm._v(_vm._s(filterItem.label) + " ")]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showHistory,
                                              expression: "showHistory",
                                            },
                                          ],
                                          staticStyle: {
                                            position: "relative",
                                            "margin-top": "2px",
                                            "margin-left": "2px",
                                          },
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "primary",
                                          },
                                          on: { click: _vm.toggleSorting },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                              "padding-left": "13px",
                                            },
                                          },
                                          [_vm._v("fas fa-clock ")]
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticStyle: {
                                              "font-size": "16px",
                                              "padding-right": "8px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.historySorting
                                                  ? "fas fa-long-arrow-alt-up"
                                                  : "fas fa-long-arrow-alt-down"
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1552054160
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                `Sort by time (${
                                  _vm.historySorting === _vm.ALERT_SORTS.DESC
                                    ? "descending"
                                    : "ascending"
                                })`
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-hover", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ hover }) {
                      return [
                        _c(
                          "div",
                          [
                            _c("v-badge", {
                              staticClass:
                                "mt-4 mr-3 drawer-helper2 badge-shadow",
                              staticStyle: { "z-index": "1" },
                              attrs: {
                                content:
                                  _vm.totalAlerts < 100
                                    ? _vm.totalAlerts
                                    : "99+",
                              },
                            }),
                            _c(
                              "v-btn",
                              {
                                staticClass: "drawer-helper2",
                                attrs: { color: "primary", small: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.$vuetify.breakpoint.smAndDown ||
                                    _vm.isNotDesktop
                                      ? (_vm.issuesDrawer = true)
                                      : () => {}
                                  },
                                },
                              },
                              [
                                _vm.$vuetify.breakpoint.mdAndUp
                                  ? _c(
                                      "v-icon",
                                      {
                                        staticStyle: {
                                          "font-size": "16px",
                                          "margin-right": "6px",
                                          "margin-bottom": "1px",
                                        },
                                      },
                                      [_vm._v("fas fa-caret-left ")]
                                    )
                                  : _vm._e(),
                                _vm._v(" ALERTS "),
                              ],
                              1
                            ),
                            !_vm.isNotDesktop
                              ? _c("div", {
                                  staticClass: "drawer-helper",
                                  staticStyle: { "z-index": "1" },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "absolute",
                                class: _vm.alertDrawerMobile
                                  ? _vm.issuesDrawer
                                    ? "issues-action-drawer"
                                    : "issues-action-drawer-none"
                                  : hover
                                  ? "issues-action-drawer"
                                  : "issues-action-drawer-none",
                              },
                              [
                                _c(
                                  "v-list",
                                  {
                                    staticStyle: {
                                      height: "100%",
                                      "border-bottom": "1px solid gray",
                                      "border-top": "1px solid gray",
                                    },
                                    attrs: { color: "transparent", dense: "" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          height: "100%",
                                          "overflow-y": "auto !important",
                                        },
                                        attrs: { id: "active-issue-actions" },
                                        on: {
                                          scroll: (ev) =>
                                            _vm.syncScroll(
                                              "active-issues",
                                              "active-issue-actions",
                                              _vm.alertCards.length,
                                              ev,
                                              0
                                            ),
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticStyle: {
                                            height: "1px",
                                            "margin-top": "67px",
                                          },
                                        }),
                                        _vm._l(
                                          _vm.alertDrawerCards,
                                          function (alertDrawerCard) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: alertDrawerCard
                                                  .alertStatistics.alertCardId,
                                                staticClass:
                                                  "issuesActions-list",
                                                staticStyle: {
                                                  "max-height": "31px",
                                                },
                                              },
                                              [
                                                _c("v-hover", {
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          hover,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  alertDrawerCard.hovered ||
                                                                  hover
                                                                    ? "issue-action"
                                                                    : "hide-issue-action pl-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-row",
                                                                  [
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3 ml-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.isNotDesktop,
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      _vm._g(
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              height:
                                                                                                "28px",
                                                                                              width:
                                                                                                "28px",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                            },
                                                                                        },
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "icon-edit-21x21",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "28px",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                function (
                                                                                                  $event
                                                                                                ) {
                                                                                                  return _vm.editAlertIssue(
                                                                                                    alertDrawerCard
                                                                                                  )
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path1 letterSpacing0",
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path2",
                                                                                              }
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Edit"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3 ml-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.isNotDesktop,
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      _vm._g(
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              height:
                                                                                                "28px",
                                                                                              width:
                                                                                                "28px",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              disabled:
                                                                                                !_vm.isAdmin,
                                                                                              icon: "",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.confirmDelete(
                                                                                                  alertDrawerCard
                                                                                                    .alertStatistics
                                                                                                    .alertCardId,
                                                                                                  alertDrawerCard
                                                                                                    .alertStatistics
                                                                                                    .name
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "ml-1",
                                                                                            class:
                                                                                              _vm.isAdmin
                                                                                                ? "icon-delete-21x21"
                                                                                                : "icon-delete-21x21-disabled",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "28px",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path1 letterSpacing0",
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path2",
                                                                                              }
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Delete alert card"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "mt-3 ml-1",
                                                                        attrs: {
                                                                          disabled:
                                                                            _vm.isNotDesktop,
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      _vm._g(
                                                                                        {
                                                                                          staticStyle:
                                                                                            {
                                                                                              height:
                                                                                                "28px",
                                                                                              width:
                                                                                                "28px",
                                                                                              "margin-left":
                                                                                                "2px",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              icon: "",
                                                                                            },
                                                                                          on: {
                                                                                            click:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                return _vm.confirmHistoryDelete(
                                                                                                  alertDrawerCard
                                                                                                )
                                                                                              },
                                                                                          },
                                                                                        },
                                                                                        on
                                                                                      ),
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "ml-1 icon-delete-21x21",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "28px",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path1 letterSpacing0",
                                                                                              }
                                                                                            ),
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "path2",
                                                                                              }
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "i",
                                                                                          {
                                                                                            staticClass:
                                                                                              "fas fa-clock",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "font-size":
                                                                                                  "10px",
                                                                                                position:
                                                                                                  "absolute",
                                                                                                top: "12px",
                                                                                                right:
                                                                                                  "6px",
                                                                                                background:
                                                                                                  "#47bd96",
                                                                                                "border-radius":
                                                                                                  "10px",
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            true
                                                                          ),
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              "Delete alert history " +
                                                                                _vm._s(
                                                                                  _vm.selectedCard !=
                                                                                    null &&
                                                                                    _vm
                                                                                      .$vuetify
                                                                                      .breakpoint
                                                                                      .mdAndUp
                                                                                    ? `of ${_vm.selectedCard.name}`
                                                                                    : ""
                                                                                )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("alerts-drawer", {
                              ref: "alertsDrawer",
                              attrs: {
                                alertCards: _vm.alertDrawerCards,
                                isNotDesktop: _vm.isNotDesktop,
                                getAlertDrawerValue:
                                  _vm.getAlertDrawerValue(hover),
                                alertDrawerClipped: _vm.alertDrawerClipped,
                              },
                              on: {
                                "toggle-issues-drawer": (ev) =>
                                  (_vm.issuesDrawer = ev),
                                "toggle-alert-drawer-clipped":
                                  _vm.clipAlertsDrawer,
                                "create-alert": _vm.createAlert,
                                "show-all-history": _vm.showAllHistory,
                                "card-selected": _vm.cardSelected,
                                "show-active-issue-actions":
                                  _vm.showAlertCardActions,
                                "hide-active-issue-actions":
                                  _vm.hideAlertCardActions,
                                "alert-card-action": function ($event) {
                                  return _vm.alertCardAction(
                                    $event,
                                    !$event.alertStatistics.enabled
                                      ? _vm.ALERT_CARD_ACTIONS.DISABLE
                                      : _vm.ALERT_CARD_ACTIONS.ENABLE,
                                    "enabled"
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.$vuetify.breakpoint.mdAndUp
                ? _c(
                    "div",
                    {
                      class: {
                        "tw-btn-container-right":
                          _vm.$vuetify.breakpoint.mdAndUp,
                        "tw-btn-container-right-mobile":
                          _vm.$vuetify.breakpoint.smAndDown,
                      },
                      style: {
                        marginRight:
                          _vm.$vuetify.breakpoint.mdAndUp &&
                          _vm.alertDrawerClipped === true
                            ? "148px"
                            : 0,
                      },
                    },
                    [
                      _c("ToggleDenseGrid", {
                        attrs: { "is-not-desktop": _vm.isNotDesktop },
                        model: {
                          value: _vm.isDenseGrid,
                          callback: function ($$v) {
                            _vm.isDenseGrid = $$v
                          },
                          expression: "isDenseGrid",
                        },
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          class: {
                                            "tw-mute-btn":
                                              _vm.$vuetify.breakpoint.mdAndUp,
                                            "tw-mute-btn-mobile":
                                              _vm.$vuetify.breakpoint.smAndDown,
                                            "tw-mute-show-history":
                                              _vm.showHistory,
                                            "tw-mute-admin": _vm.isAdmin,
                                          },
                                          staticStyle: { "margin-top": "2px" },
                                          attrs: {
                                            text: "",
                                            icon: "",
                                            "aria-label": "volume",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "mute-trade-watcher"
                                              )
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _vm.tradeWatcherMute
                                          ? _c(
                                              "v-icon",
                                              { attrs: { color: "grey" } },
                                              [_vm._v("volume_off")]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: _vm.$vuetify.theme.dark
                                                    ? "white"
                                                    : "grey",
                                                },
                                              },
                                              [_vm._v("volume_up ")]
                                            ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4121752538
                          ),
                        },
                        [_c("span", [_vm._v(" Mute Trade Watcher ")])]
                      ),
                      _vm.isAdmin
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g(
                                            _vm._b({}, "div", attrs, false),
                                            on
                                          ),
                                          [
                                            _c("data-transfer", {
                                              attrs: {
                                                cards: _vm.alertCards,
                                                types: _vm.alertTypes,
                                              },
                                              on: { refresh: _vm.refresh },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2198253680
                              ),
                            },
                            [_c("span", [_vm._v("Data")])]
                          )
                        : _vm._e(),
                      _vm.isAdmin
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              class: _vm.$vuetify.breakpoint
                                                .mdAndUp
                                                ? "tw-admin-btn"
                                                : "tw-admin-btn-mobile",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getAlertTypes(
                                                    true,
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "22px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "icon-configurations-19x19"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2756650482
                              ),
                            },
                            [_c("span", [_vm._v("Configure Alert Types")])]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                {
                  class: {
                    "pr-279px":
                      _vm.alertDrawerClipped && _vm.$vuetify.breakpoint.mdAndUp,
                  },
                  staticStyle: { height: "37px" },
                  style: _vm.$vuetify.theme.dark
                    ? "border-bottom: 1px solid #1C6E59;"
                    : "border-bottom: 1px solid #adadb2;",
                  attrs: { justify: "center" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "pl-3 my-auto",
                      class: {
                        "tw-tabs-wrap": _vm.$vuetify.breakpoint.width > 700,
                      },
                      style:
                        _vm.$vuetify.breakpoint.width < 701
                          ? "height:20px !important;"
                          : "height:36px;",
                      on: {
                        click: function ($event) {
                          return _vm.switchTab(0)
                        },
                      },
                    },
                    [
                      _vm.$vuetify.breakpoint.width > 700
                        ? _c(
                            "p",
                            {
                              staticClass: "mr-2 mb-0 secondary-h1",
                              class: {
                                "black--text":
                                  !_vm.$vuetify.theme.dark && _vm.showHistory,
                                "tw-clicked-tab": !_vm.showHistory,
                              },
                              staticStyle: {
                                "margin-top": "6px",
                                "font-size": "16px",
                              },
                            },
                            [_vm._v(" Alert Cards ")]
                          )
                        : _c(
                            "v-icon",
                            {
                              staticClass: "mb-1 mr-2",
                              class: { "tw-clicked-tab": !_vm.showHistory },
                              staticStyle: { "font-size": "19px" },
                              attrs: { small: "" },
                            },
                            [_vm._v(" fab fa-wpforms ")]
                          ),
                    ],
                    1
                  ),
                  _c("hr", {
                    staticStyle: { height: "20px", "margin-top": "8px" },
                    attrs: {
                      width: "1",
                      color: _vm.$vuetify.theme.dark ? "grey" : "primary",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "pr-3 my-auto",
                      class: {
                        "tw-tabs-wrap": _vm.$vuetify.breakpoint.width > 700,
                      },
                      staticStyle: { height: "36px" },
                      style:
                        _vm.$vuetify.breakpoint.width < 701
                          ? "height:20px !important;"
                          : "height:36px;",
                      on: {
                        click: function ($event) {
                          return _vm.switchTab(1)
                        },
                      },
                    },
                    [
                      _vm.$vuetify.breakpoint.width > 700
                        ? _c(
                            "p",
                            {
                              staticClass: "ml-2 secondary-h1",
                              class: {
                                "black--text":
                                  !_vm.$vuetify.theme.dark & !_vm.showHistory,
                                "tw-clicked-tab": _vm.showHistory,
                              },
                              staticStyle: {
                                "margin-top": "6px",
                                "font-size": "16px",
                              },
                            },
                            [
                              _vm._v(
                                " History " +
                                  _vm._s(
                                    _vm.showingAllHistory
                                      ? "of all"
                                      : _vm.selectedCard != null &&
                                        _vm.$vuetify.breakpoint.mdAndUp
                                      ? ` of ${_vm.selectedCard.name}`
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "v-icon",
                            {
                              staticClass: "ml-2",
                              class: { "tw-clicked-tab": _vm.showHistory },
                              staticStyle: {
                                "margin-bottom": "5px",
                                "font-size": "18px",
                              },
                              attrs: { small: "" },
                            },
                            [_vm._v(" fas fa-history ")]
                          ),
                    ],
                    1
                  ),
                ]
              ),
              _vm.$vuetify.breakpoint.smAndDown
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "tw-btn-container-mobile",
                        style: _vm.$vuetify.theme.dark
                          ? "background-color: rgba(250,250,250,0.1)"
                          : "background-color: rgba(0,0,0,0.1)",
                      },
                      [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "open-on-hover": !_vm.isNotDesktop,
                              "offset-y": "",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.showHistory,
                                                expression: "showHistory",
                                              },
                                            ],
                                            class: {
                                              "primary--text":
                                                _vm.historyFilter !== "all",
                                            },
                                            staticStyle: {
                                              "margin-top": "2px",
                                            },
                                            attrs: { icon: "", small: "" },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                              },
                                            },
                                            [_vm._v("fas fa-filter")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1662547939
                            ),
                          },
                          [
                            _c(
                              "v-list",
                              { staticClass: "py-0", attrs: { dense: "" } },
                              [
                                _c(
                                  "v-subheader",
                                  {
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        $event.preventDefault()
                                      },
                                    },
                                  },
                                  [_vm._v(" Filter ")]
                                ),
                                _vm._l(_vm.filters, function (filterItem) {
                                  return _c(
                                    "v-list-item",
                                    {
                                      key: `filter-option-${filterItem.value}`,
                                      staticClass: "accent",
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeHistoryFilter(
                                            filterItem.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "ma-0" },
                                        [
                                          filterItem.value === "all"
                                            ? _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "primary--text":
                                                      _vm.historyFilter ===
                                                      "all",
                                                  },
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                  },
                                                },
                                                [_vm._v("fas fa-th ")]
                                              )
                                            : _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "primary--text":
                                                      filterItem.checked ===
                                                      true,
                                                  },
                                                  staticStyle: {
                                                    "font-size": "14px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        !!filterItem.checked
                                                          ? "far fa-check-circle"
                                                          : "far fa-circle"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-title",
                                        {
                                          class: {
                                            "primary--text":
                                              !!filterItem.checked,
                                          },
                                        },
                                        [_vm._v(_vm._s(filterItem.label) + " ")]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.showHistory,
                                                expression: "showHistory",
                                              },
                                            ],
                                            staticStyle: {
                                              position: "relative",
                                              "margin-top": "2px",
                                              "margin-left": "2px",
                                            },
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              color: "primary",
                                            },
                                            on: { click: _vm.toggleSorting },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                                "padding-left": "13px",
                                              },
                                            },
                                            [_vm._v("fas fa-clock ")]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticStyle: {
                                                "font-size": "16px",
                                                "padding-right": "8px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.historySorting
                                                    ? "fas fa-long-arrow-alt-up"
                                                    : "fas fa-long-arrow-alt-down"
                                                ) + " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1552054160
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  `Sort by time (${
                                    _vm.historySorting === _vm.ALERT_SORTS.DESC
                                      ? "descending"
                                      : "ascending"
                                  })`
                                )
                              ),
                            ]),
                          ]
                        ),
                        _c("v-spacer"),
                        _c("ToggleDenseGrid", {
                          attrs: { "is-not-desktop": _vm.isNotDesktop },
                          model: {
                            value: _vm.isDenseGrid,
                            callback: function ($$v) {
                              _vm.isDenseGrid = $$v
                            },
                            expression: "isDenseGrid",
                          },
                        }),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { disabled: _vm.isNotDesktop, bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            class: {
                                              "tw-mute-btn":
                                                _vm.$vuetify.breakpoint.mdAndUp,
                                              "tw-mute-btn-mobile":
                                                _vm.$vuetify.breakpoint
                                                  .smAndDown,
                                              "tw-mute-show-history":
                                                _vm.showHistory,
                                              "tw-mute-admin": _vm.isAdmin,
                                            },
                                            staticStyle: {
                                              "margin-top": "2px",
                                            },
                                            attrs: {
                                              text: "",
                                              icon: "",
                                              "aria-label": "volume",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "mute-trade-watcher"
                                                )
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm.tradeWatcherMute
                                            ? _c(
                                                "v-icon",
                                                { attrs: { color: "grey" } },
                                                [_vm._v("volume_off")]
                                              )
                                            : _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    color: _vm.$vuetify.theme
                                                      .dark
                                                      ? "white"
                                                      : "grey",
                                                  },
                                                },
                                                [_vm._v("volume_up ")]
                                              ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4121752538
                            ),
                          },
                          [_c("span", [_vm._v(" Mute Trade Watcher ")])]
                        ),
                        _vm.isAdmin
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b({}, "div", attrs, false),
                                              on
                                            ),
                                            [
                                              _c("data-transfer", {
                                                attrs: {
                                                  cards: _vm.alertCards,
                                                  types: _vm.alertTypes,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  103173275
                                ),
                              },
                              [_c("span", [_vm._v("Data")])]
                            )
                          : _vm._e(),
                        _vm.isAdmin
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "div",
                                            _vm._g(
                                              _vm._b({}, "div", attrs, false),
                                              on
                                            ),
                                            [
                                              _c("data-transfer", {
                                                attrs: {
                                                  cards: _vm.alertCards,
                                                  types: _vm.alertTypes,
                                                },
                                                on: { refresh: _vm.refresh },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2198253680
                                ),
                              },
                              [_c("span", [_vm._v("Data")])]
                            )
                          : _vm._e(),
                        _vm.isAdmin
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                class: _vm.$vuetify.breakpoint
                                                  .mdAndUp
                                                  ? "tw-admin-btn"
                                                  : "tw-admin-btn-mobile",
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.getAlertTypes(
                                                      true,
                                                      true
                                                    )
                                                  },
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size": "22px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "icon-configurations-19x19"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2756650482
                                ),
                              },
                              [_c("span", [_vm._v("Configure Alert Types")])]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c(
                "v-row",
                { staticClass: "mx-0 fullSize", attrs: { justify: "start" } },
                [
                  _vm.loadingAlertHistory && _vm.showHistory
                    ? _c(
                        "v-row",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "100%",
                            "align-content": "center",
                          },
                          attrs: { justify: "center" },
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: 30,
                              color: "primary",
                              indeterminate: "",
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          class: _vm.alertContainerClasses,
                          staticStyle: {
                            "overflow-y": "auto",
                            "overflow-x": "hidden",
                          },
                          attrs: { id: "alert-cards-wrapper" },
                        },
                        [
                          _vm.cards.length
                            ? _c(
                                "v-row",
                                { staticClass: "mx-1" },
                                _vm._l(_vm.cards, function (card, i) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: _vm.showHistory
                                        ? card.id
                                        : card.alertStatistics.alertCardId,
                                      class: _vm.isDenseGrid
                                        ? "alert-card-wrap"
                                        : "",
                                      attrs: {
                                        lg: _vm.getCardsLGLayout,
                                        md: _vm.alertDrawerClipped ? 6 : 4,
                                        sm: "6",
                                        cols: "12",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-lazy",
                                        {
                                          attrs: {
                                            options: {
                                              threshold: 0.1,
                                            },
                                            "min-height": "200",
                                            transition: "fade-transition",
                                            value: true,
                                          },
                                        },
                                        [
                                          _c("alert-card", {
                                            attrs: {
                                              id: _vm.showHistory
                                                ? card.id
                                                : card.alertStatistics
                                                    .alertCardId,
                                              showHistory: _vm.showHistory,
                                              cardInfo: _vm.showHistory
                                                ? card
                                                : card.alertStatistics,
                                              sourceNames: card.sourceNames,
                                              isNotDesktop: _vm.isNotDesktop,
                                              infoTabsProp: _vm.infoTabs,
                                              cardIndex: i,
                                            },
                                            on: {
                                              "update:infoTabs": function (
                                                $event
                                              ) {
                                                _vm.infoTabs = $event
                                              },
                                              "card-selected": _vm.cardSelected,
                                              acknowledge: _vm.acknowledge,
                                              "delete-history-card": function (
                                                $event
                                              ) {
                                                return _vm.deleteHistoryCard(
                                                  card
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _c(
                                "v-row",
                                {
                                  staticClass: "mx-0 fullSize",
                                  attrs: { justify: "center" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { "align-self": "center" } },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { justify: "center" } },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticStyle: { color: "#d4d4d4" },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.showHistory
                                                      ? _vm.getEmptyHistoryStateText
                                                      : "No alert cards"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !!_vm.showHistory,
                      expression: "!!showHistory",
                    },
                  ],
                  staticClass: "mx-0",
                  class: {
                    "pr-279px":
                      _vm.alertDrawerClipped && _vm.$vuetify.breakpoint.mdAndUp,
                    "tw-footer-touchscreen": _vm.isNotDesktop,
                    "tw-footer": !_vm.isNotDesktop,
                  },
                  attrs: { justify: "space-between", "justify-sm": "end" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ml-2",
                      staticStyle: {
                        height: "44px",
                        display: "flex",
                        "align-items": "center",
                        "font-size": "0.75rem",
                      },
                    },
                    [
                      _vm.$vuetify.breakpoint.smAndUp
                        ? _c(
                            "div",
                            {
                              staticClass: "mr-6",
                              class: { "grey--text": !_vm.showHistory },
                            },
                            [_vm._v(" Rows per page: ")]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "footer-items-wrapper",
                          class: { "mr-1": _vm.$vuetify.breakpoint.smAndUp },
                        },
                        [
                          _c("v-select", {
                            staticClass: "footer-items-per-page mt-0",
                            attrs: {
                              dense: "",
                              disabled: !_vm.showHistory,
                              "hide-details": "",
                              "menu-props": { top: true, offsetY: true },
                              items: [10, 25, 50, 100],
                            },
                            on: {
                              change: function ($event) {
                                return _vm.paginationChangeHandler(1)
                              },
                            },
                            model: {
                              value: _vm.itemsPerPage,
                              callback: function ($$v) {
                                _vm.itemsPerPage = $$v
                              },
                              expression: "itemsPerPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    [
                      _c("v-pagination", {
                        key: _vm.paginationRenderKey,
                        staticClass: "pagination",
                        attrs: {
                          value: _vm.page,
                          length: _vm.totalPages,
                          "total-visible": _vm.$vuetify.breakpoint.xsOnly
                            ? 5
                            : 7,
                          circle: "",
                        },
                        on: { input: _vm.paginationChangeHandler },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "v-dialog",
                {
                  attrs: {
                    width: "683",
                    "overlay-color": "grey darken-2",
                    transition: "scroll-x-transition",
                    persistent: "",
                  },
                  model: {
                    value: _vm.queryDialog,
                    callback: function ($$v) {
                      _vm.queryDialog = $$v
                    },
                    expression: "queryDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticStyle: {
                        "max-width": "750px",
                        "min-height": "200px",
                      },
                      attrs: { color: "accent" },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticStyle: {
                            "background-color": "#47bd96",
                            color: "white",
                          },
                          attrs: { dark: "" },
                        },
                        [_vm._v(" Query Editor ")]
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mx-0", attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-4 pb-0", attrs: { cols: "12" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "formatted-query-wrapper",
                                  staticStyle: {
                                    border: "1px solid #9fa6bf",
                                    "border-radius": "4px",
                                  },
                                },
                                [
                                  _c("v-textarea", {
                                    staticClass: "formatted-query",
                                    attrs: {
                                      role: "textbox",
                                      "min-height": 400,
                                    },
                                    model: {
                                      value: _vm.formattedQuery,
                                      callback: function ($$v) {
                                        _vm.formattedQuery = $$v
                                      },
                                      expression: "formattedQuery",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.formatQuery()
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "mr-1", attrs: { small: "" } },
                                [_vm._v(" fas fa-magic")]
                              ),
                              _vm._v(" Format "),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "ml-0 mb-1 mr-1",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showFormatSettings =
                                    !_vm.showFormatSettings
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.showFormatSettings
                                      ? "primary"
                                      : "white",
                                    small: "",
                                  },
                                },
                                [_vm._v(" fas fa-cog ")]
                              ),
                            ],
                            1
                          ),
                          _vm.showFormatSettings
                            ? _c("div", [_vm._v("Spaces")])
                            : _vm._e(),
                          _vm.showFormatSettings
                            ? _c(
                                "div",
                                {
                                  staticClass: "ml-2",
                                  staticStyle: { width: "30px" },
                                },
                                [
                                  _c("v-text-field", {
                                    staticClass: "mt-1",
                                    attrs: { type: "number", dense: "" },
                                    model: {
                                      value: _vm.querySpaces,
                                      callback: function ($$v) {
                                        _vm.querySpaces = _vm._n($$v)
                                      },
                                      expression: "querySpaces",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function ($event) {
                                  _vm.queryDialog = !_vm.queryDialog
                                },
                              },
                            },
                            [_vm._v("cancel")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "primary" },
                              on: { click: _vm.acceptQueryFormat },
                            },
                            [_vm._v("ok")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "750",
            "overlay-color": "grey darken-2",
            transition: "scroll-x-transition",
            "content-class": "d-dialog-panel",
            persistent: "",
          },
          model: {
            value: _vm.twAdminDialog,
            callback: function ($$v) {
              _vm.twAdminDialog = $$v
            },
            expression: "twAdminDialog",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "insideRows-no-mx",
              staticStyle: { "max-width": "750px" },
              attrs: { color: "accent" },
            },
            [
              _c(
                "v-card-title",
                {
                  staticStyle: {
                    "background-color": "#47bd96",
                    color: "white",
                    "letter-spacing": "0.03rem",
                  },
                  style: _vm.$vuetify.breakpoint.xsOnly
                    ? "text-align: center !important;"
                    : "",
                },
                [_vm._v("Configure Alert Types ")]
              ),
              _c(
                "v-form",
                {
                  ref: "adminForm",
                  model: {
                    value: _vm.adminForm,
                    callback: function ($$v) {
                      _vm.adminForm = $$v
                    },
                    expression: "adminForm",
                  },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mx-1",
                      staticStyle: {
                        "overflow-y": "auto",
                        "max-height": "780px",
                      },
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "pb-0",
                              staticStyle: {
                                "font-size": "16px",
                                "font-weight": "400",
                                "letter-spacing": "0.03rem",
                              },
                            },
                            [_vm._v(" Types ")]
                          ),
                          _c("v-simple-table", {
                            staticClass: "stylish-text typesTable mx-2",
                            staticStyle: {
                              "border-radius": "6px 6px 0 0",
                              "max-height": "206px",
                              "overflow-y": "auto",
                            },
                            attrs: { dense: "", "fixed-header": "" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function () {
                                  return [
                                    _c("thead", [
                                      _c("tr", [
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-left typesTable",
                                            staticStyle: {
                                              "border-radius": "6px 6px 0 0",
                                            },
                                          },
                                          [_vm._v(" Name ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-left typesTable",
                                            staticStyle: {
                                              "border-radius": "6px 6px 0 0",
                                            },
                                          },
                                          [_vm._v(" Description ")]
                                        ),
                                        _c(
                                          "th",
                                          {
                                            staticClass: "text-left typesTable",
                                            staticStyle: {
                                              "border-radius": "6px 6px 0 0",
                                              "text-align": "center !important",
                                            },
                                          },
                                          [_vm._v(" Actions ")]
                                        ),
                                      ]),
                                    ]),
                                    !_vm.alertTypes.length
                                      ? _c(
                                          "td",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: { colspan: "3" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-center mt-5 mb-0",
                                                staticStyle: {
                                                  color:
                                                    "rgb(255, 255, 255, 0.5)",
                                                },
                                              },
                                              [_vm._v(" No alert types yet ")]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "tbody",
                                          _vm._l(
                                            _vm.alertTypes,
                                            function (alertType) {
                                              return _c(
                                                "tr",
                                                {
                                                  key: alertType.id,
                                                  class:
                                                    _vm.alertTypeEditing &&
                                                    alertType.id ===
                                                      _vm.alertTypeEditing.id
                                                      ? "types-table-item-selected"
                                                      : "types-table-item-unselected types-table-item",
                                                },
                                                [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "clickableText",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editAlertType(
                                                            alertType
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-row", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              alertType.name
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "clickableText",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editAlertType(
                                                            alertType
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            alertType.description
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "td",
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticStyle: {
                                                            "min-width": "72px",
                                                          },
                                                          attrs: {
                                                            justify: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.deleteAlertType(
                                                                      alertType
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "icon-delete-21x21",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "28px",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "path1 letterSpacing0",
                                                                  }),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "path2",
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "-1px",
                                                                      },
                                                                  }),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-badge", {
                                                            key: _vm.unsavedMsgRenderKey,
                                                            class: {
                                                              "badge-small":
                                                                alertType.unsaved,
                                                            },
                                                            attrs: {
                                                              "offset-x": "16",
                                                              "offset-y": "12",
                                                              value:
                                                                alertType.unsaved ||
                                                                false,
                                                              color: "red",
                                                              icon: "fas fa-exclamation",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c(
                            "v-row",
                            {
                              staticClass: "typesTable mx-2",
                              attrs: { justify: "start" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mt-2 ml-0",
                                  staticStyle: { "font-size": "14px" },
                                  attrs: { text: "", color: "primary" },
                                  on: { click: _vm.addAlertType },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas fa-plus-circle mr-1",
                                    staticStyle: { color: "#47bd96" },
                                  }),
                                  _vm._v("Add type "),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.alertTypeEditing != null && _vm.alertTypes.length
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticStyle: {
                                    "font-size": "16px",
                                    "font-weight": "400",
                                    "letter-spacing": "0.03rem",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.alertTypeEditing.name) +
                                      " "
                                  ),
                                  _c(
                                    "p",
                                    {
                                      key: _vm.unsavedMsgRenderKey,
                                      staticClass: "ml-3",
                                      staticStyle: {
                                        "margin-bottom": "-2px",
                                        "margin-top": "2px",
                                        color: "#d32f2f",
                                        "font-size": "15px",
                                        "font-weight": "400",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.alertTypeEditing.unsaved
                                              ? "(Unsaved)"
                                              : ""
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    centered: "",
                                    "hide-slider": "",
                                    "background-color": "accent",
                                  },
                                  model: {
                                    value: _vm.alertTypeTabs,
                                    callback: function ($$v) {
                                      _vm.alertTypeTabs = $$v
                                    },
                                    expression: "alertTypeTabs",
                                  },
                                },
                                [
                                  _c(
                                    "v-tab",
                                    {
                                      attrs: {
                                        "active-class": "primary--text",
                                      },
                                      on: { click: _vm.updateMessageFormat },
                                    },
                                    [_vm._v("Settings ")]
                                  ),
                                  _c(
                                    "v-tab",
                                    {
                                      attrs: {
                                        "active-class": "primary--text",
                                      },
                                    },
                                    [_vm._v("Appearance")]
                                  ),
                                  _c(
                                    "v-tabs-items",
                                    {
                                      staticClass: "accent",
                                      model: {
                                        value: _vm.alertTypeTabs,
                                        callback: function ($$v) {
                                          _vm.alertTypeTabs = $$v
                                        },
                                        expression: "alertTypeTabs",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "pt-4",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      label: "Name",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .name,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing,
                                                          "name",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.name",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      label: "Description",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .description,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing,
                                                          "description",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.description",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      label: "Query",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "append",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-top":
                                                                      "-3px",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                        color:
                                                                          "primary",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          _vm.openQueryDialog,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "fas fa-expand "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c(
                                                                    "v-tooltip",
                                                                    {
                                                                      attrs: {
                                                                        bottom:
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function ({
                                                                                on,
                                                                              }) {
                                                                                return [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    _vm._g(
                                                                                      {
                                                                                        staticStyle:
                                                                                          {
                                                                                            "margin-right":
                                                                                              "-4px !important",
                                                                                            "margin-left":
                                                                                              "2px !important",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            icon: "",
                                                                                            small:
                                                                                              "",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            _vm.modifyQueryValidation,
                                                                                        },
                                                                                      },
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          key: _vm.queryValidationRenderKey,
                                                                                          attrs:
                                                                                            {
                                                                                              small:
                                                                                                "",
                                                                                              color:
                                                                                                _vm
                                                                                                  .alertTypeEditing
                                                                                                  .skipQueryValidation
                                                                                                  ? "white"
                                                                                                  : "primary",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "fas fa-spell-check "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          false,
                                                                          2678400200
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          key: _vm.queryValidationRenderKey,
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Query validation: "
                                                                          ),
                                                                          _c(
                                                                            "b",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .alertTypeEditing
                                                                                    .skipQueryValidation
                                                                                    ? "OFF"
                                                                                    : "ON"
                                                                                ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                !_vm
                                                                                  .alertTypeEditing
                                                                                  .skipQueryValidation
                                                                                  ? " (default)"
                                                                                  : ""
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                          _c(
                                                                            "br"
                                                                          ),
                                                                          _vm._v(
                                                                            " Validate the query for any mistakes when saving the alert type "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3629497078
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .query,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing,
                                                          "query",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.query",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      label: "Scope",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .scope,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing,
                                                          "scope",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.scope",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "6",
                                                  },
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      outlined: "",
                                                      dense: "",
                                                      "menu-props": {
                                                        offsetY: true,
                                                        maxHeight: "250",
                                                      },
                                                      label: _vm
                                                        .alertTypeEditing
                                                        .arguments.length
                                                        ? `Metric Arguments: ${_vm.alertTypeEditing.arguments.length}`
                                                        : "No arguments yet",
                                                      "no-data-text":
                                                        "No arguments yet",
                                                      items:
                                                        _vm.alertTypeEditing
                                                          .arguments,
                                                      "return-object": "",
                                                      "item-text":
                                                        "friendlyName",
                                                      "item-value": "id",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "prepend-item",
                                                          fn: function () {
                                                            return [
                                                              _c(
                                                                "v-list-item",
                                                                {
                                                                  staticStyle: {
                                                                    "max-height":
                                                                      "40px",
                                                                    "border-bottom":
                                                                      "1px solid #7f7f7f",
                                                                  },
                                                                  attrs: {
                                                                    ripple: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      _vm.addNewMetricArgument,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-content",
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "font-size":
                                                                                "14px !important",
                                                                              "font-weight":
                                                                                "400",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "fas fa-plus-circle mr-1",
                                                                              staticStyle:
                                                                                {
                                                                                  color:
                                                                                    "#47bd96",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " New argument "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1168343716
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedATArgument,
                                                      callback: function ($$v) {
                                                        _vm.selectedATArgument =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedATArgument",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-0",
                                                  attrs: { cols: "6" },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-checkbox", {
                                                        staticClass:
                                                          "aggregated-checkbox mt-0",
                                                        staticStyle: {
                                                          "font-size":
                                                            "8px !important",
                                                        },
                                                        attrs: {
                                                          small: "",
                                                          dense: "",
                                                          label: "Aggregated",
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            _vm.hasChanges = true
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.alertTypeEditing
                                                              .isDistributedQuery,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.alertTypeEditing,
                                                              "isDistributedQuery",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "alertTypeEditing.isDistributedQuery",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.selectedATArgument.id > -1
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "mx-2",
                                                  staticStyle: {
                                                    border: "1px solid #47bd96",
                                                    "border-radius": "4px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "pl-3 mt-1",
                                                      staticStyle: {
                                                        "font-size": "16px",
                                                        "letter-spacing":
                                                          "0.03rem",
                                                        color: "#47bd96",
                                                      },
                                                      attrs: {
                                                        justify:
                                                          "space-between",
                                                      },
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm
                                                              .selectedATArgument
                                                              .name
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-2",
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 dense-text-fields",
                                                            staticStyle: {
                                                              height: "40px",
                                                            },
                                                            attrs: {
                                                              outlined: "",
                                                              dense: "",
                                                              label: "Name",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.hasChanges = true
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .selectedATArgument
                                                                  .name,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.selectedATArgument,
                                                                    "name",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "selectedATArgument.name",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-2",
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 dense-text-fields",
                                                            staticStyle: {
                                                              height: "40px",
                                                            },
                                                            attrs: {
                                                              outlined: "",
                                                              dense: "",
                                                              label:
                                                                "Friendly Name",
                                                              rules: [
                                                                _vm.rules
                                                                  .required,
                                                              ],
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.hasChanges = true
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .selectedATArgument
                                                                  .friendlyName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.selectedATArgument,
                                                                    "friendlyName",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "selectedATArgument.friendlyName",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-2",
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            staticClass:
                                                              "mt-0 dense-text-fields",
                                                            staticStyle: {
                                                              height: "40px",
                                                            },
                                                            attrs: {
                                                              label: "Type",
                                                              dense: "",
                                                              outlined: "",
                                                              "menu-props": {
                                                                offsetY: true,
                                                                maxHeight:
                                                                  "250",
                                                              },
                                                              items: [
                                                                "number",
                                                                "double",
                                                                "array (string)",
                                                                "array (number)",
                                                                "boolean",
                                                              ],
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.hasChanges = true
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .selectedATArgument
                                                                  .type,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.selectedATArgument,
                                                                    "type",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "selectedATArgument.type",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "pt-2",
                                                          attrs: { cols: "6" },
                                                        },
                                                        [
                                                          _c("v-text-field", {
                                                            staticClass:
                                                              "mt-0 dense-text-fields",
                                                            staticStyle: {
                                                              height: "40px",
                                                            },
                                                            attrs: {
                                                              outlined: "",
                                                              dense: "",
                                                              label:
                                                                this
                                                                  .selectedATArgument
                                                                  .type ===
                                                                "boolean"
                                                                  ? "Description"
                                                                  : "Metric Unit",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                _vm.hasChanges = true
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .selectedATArgument
                                                                  .metricUnit,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.selectedATArgument,
                                                                    "metricUnit",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "selectedATArgument.metricUnit",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.isDoubleOrNumber
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "mt-0 dense-text-fields",
                                                                  staticStyle: {
                                                                    height:
                                                                      "40px",
                                                                  },
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    label:
                                                                      "Min",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.hasChanges = true
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .selectedATArgument
                                                                        .min,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.selectedATArgument,
                                                                          "min",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "selectedATArgument.min",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.isDoubleOrNumber
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "mt-0 dense-text-fields",
                                                                  staticStyle: {
                                                                    height:
                                                                      "40px",
                                                                  },
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    label:
                                                                      "Max",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.hasChanges = true
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .selectedATArgument
                                                                        .max,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.selectedATArgument,
                                                                          "max",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "selectedATArgument.max",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.isDoubleOrNumber
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-text-field",
                                                                {
                                                                  staticClass:
                                                                    "mt-0 dense-text-fields",
                                                                  staticStyle: {
                                                                    height:
                                                                      "40px",
                                                                  },
                                                                  attrs: {
                                                                    outlined:
                                                                      "",
                                                                    dense: "",
                                                                    hint: _vm.getStepHint,
                                                                    label:
                                                                      "Step",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.hasChanges = true
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .selectedATArgument
                                                                        .step,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.selectedATArgument,
                                                                          "step",
                                                                          _vm._n(
                                                                            $$v
                                                                          )
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "selectedATArgument.step",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.isDoubleOrNumber
                                                        ? _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pt-2",
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _c("v-checkbox", {
                                                                staticClass:
                                                                  "aggregated-checkbox mt-0 ml-2",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "8px !important",
                                                                },
                                                                attrs: {
                                                                  small: "",
                                                                  dense: "",
                                                                  label:
                                                                    "Force other value",
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.hasChanges = true
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .selectedATArgument
                                                                      .plainValueOnly,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.selectedATArgument,
                                                                        "plainValueOnly",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "selectedATArgument.plainValueOnly",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-row",
                                                    {
                                                      attrs: { justify: "end" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            color: "red",
                                                            text: "",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.deleteATArgument,
                                                          },
                                                        },
                                                        [_vm._v("delete ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-tab-item",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c("v-col", {
                                                attrs: { cols: "0", sm: "1" },
                                              }),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "5",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "analyticsTextFieldClass mx-auto",
                                                    staticStyle: {
                                                      "margin-bottom": "8px",
                                                      "max-width": "250px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      placeholder:
                                                        "Column Name",
                                                      "hide-details": "",
                                                      label:
                                                        "Column names e.g Login,Equity",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .message.columnNames,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing
                                                            .message,
                                                          "columnNames",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.message.columnNames",
                                                    },
                                                  }),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "analyticsTextFieldClass mx-auto",
                                                    staticStyle: {
                                                      "max-width": "250px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      outlined: "",
                                                      placeholder:
                                                        "Column Name",
                                                      "hide-details": "",
                                                      label:
                                                        "Column numbers e.g 2,5,1",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        _vm.hasChanges = true
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.alertTypeEditing
                                                          .message
                                                          .columnNumbers,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.alertTypeEditing
                                                            .message,
                                                          "columnNumbers",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "alertTypeEditing.message.columnNumbers",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-3",
                                                  attrs: {
                                                    cols: "12",
                                                    sm: "5",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "mx-auto",
                                                      staticStyle: {
                                                        "max-width": "265px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pt-1 mx-2 pr-2 notification-history-section",
                                                          staticStyle: {
                                                            "border-radius":
                                                              "12px",
                                                            "font-size":
                                                              "12.5px",
                                                            "max-width":
                                                              "265px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "ma-0 pl-2",
                                                              staticStyle: {
                                                                "padding-top":
                                                                  "2px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-0 ml-1",
                                                                  staticStyle: {
                                                                    "letter-spacing":
                                                                      "0.6px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " Trade Watcher "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mx-1",
                                                                },
                                                                [_vm._v("-")]
                                                              ),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-0",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "11px",
                                                                    "letter-spacing":
                                                                      "0.08rem",
                                                                    "margin-top":
                                                                      "2px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .alertTypeEditing
                                                                          .name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "ma-0",
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "pl-1 mb-4",
                                                                  staticStyle: {
                                                                    float:
                                                                      "left",
                                                                    "font-size":
                                                                      "14px",
                                                                    margin:
                                                                      "8px",
                                                                    "margin-left":
                                                                      "9px",
                                                                    "margin-top":
                                                                      "9px",
                                                                  },
                                                                  attrs: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "fas fa-exclamation-triangle "
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "155px",
                                                                    float:
                                                                      "left",
                                                                    margin:
                                                                      "4px 0 4px 4px",
                                                                    "font-size":
                                                                      "11px",
                                                                  },
                                                                  attrs: {
                                                                    id: "alert-appearance-text",
                                                                    role: "textbox",
                                                                    contenteditable:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.hasChanges = true
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .alertTypeEditing
                                                                          .message
                                                                          .format
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "mr-5",
                                                          staticStyle: {
                                                            "text-align": "end",
                                                            "font-size":
                                                              "10.5px",
                                                          },
                                                        },
                                                        [_vm._v(" 11:00 ")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c("v-col", {
                                                attrs: { cols: "0", sm: "1" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2 ml-2",
                      attrs: { text: "", color: "primary" },
                      on: { click: _vm.closeAlertTypeEditor },
                    },
                    [_vm._v(" Close ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-2 mr-2",
                      attrs: {
                        text: "",
                        color: "primary",
                        disabled: !_vm.hasChanges,
                        loading: _vm.alertTypeActionLoading,
                      },
                      on: { click: _vm.saveAlertTypeHandler },
                    },
                    [_vm._v(" Save Type ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "overlay-color": "grey darken-2",
            transition: "scroll-x-transition",
            width: "700",
            persistent: "",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "accent",
              staticStyle: {
                "max-width": "700px",
                "overflow-y": "hidden !important",
              },
            },
            [
              _vm.edit
                ? _c(
                    "v-card-title",
                    {
                      staticClass: "pageTitle",
                      class: {
                        "TW-dialog-title":
                          _vm.$vuetify.breakpoint.xsOnly || _vm.isNotDesktop,
                      },
                      staticStyle: {
                        "background-color": "#47bd96",
                        color: "white",
                      },
                      style: _vm.$vuetify.breakpoint.xsOnly
                        ? "text-align: center !important;"
                        : "",
                    },
                    [
                      _c("p", { staticClass: "char-lim mx-0 mt-0 pb-3" }, [
                        _vm._v(_vm._s(_vm.currentEditIssue.name)),
                      ]),
                      !!_vm.currentEditIssue.alertType &&
                      !!_vm.currentEditIssue.alertType.name &&
                      _vm.currentEditIssue.alertType.name.length > 0
                        ? _c("p", { staticClass: "ml-1" }, [
                            _vm._v(
                              _vm._s(
                                "(" + _vm.currentEditIssue.alertType.name + ")"
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                : _c(
                    "v-card-title",
                    {
                      staticClass: "pageTitle",
                      staticStyle: {
                        "background-color": "#47bd96",
                        color: "white",
                      },
                      style: _vm.$vuetify.breakpoint.xsOnly
                        ? "text-align: center !important;"
                        : "",
                    },
                    [_vm._v("New Alert ")]
                  ),
              !_vm.edit
                ? _c(
                    "div",
                    [
                      _c(
                        "v-stepper",
                        {
                          style: `max-height: ${
                            _vm.$vuetify.breakpoint.height - 200
                          }px;overflow-y:auto;`,
                          attrs: { flat: "", vertical: "" },
                          model: {
                            value: _vm.wizard,
                            callback: function ($$v) {
                              _vm.wizard = $$v
                            },
                            expression: "wizard",
                          },
                        },
                        [
                          _c(
                            "v-stepper-step",
                            { attrs: { complete: _vm.wizard > 1, step: "1" } },
                            [
                              _vm._v(
                                " Alert " +
                                  _vm._s(
                                    _vm.newAlert.name
                                      ? ": " + _vm.newAlert.name
                                      : ""
                                  ) +
                                  " " +
                                  _vm._s(
                                    _vm.selectedAlertType.name
                                      ? "(" + _vm.selectedAlertType.name + ")"
                                      : ""
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "1" } },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "newAlertForm",
                                  model: {
                                    value: _vm.validForm1,
                                    callback: function ($$v) {
                                      _vm.validForm1 = $$v
                                    },
                                    expression: "validForm1",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pt-1",
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "dense-textarea",
                                            attrs: {
                                              autofocus: "",
                                              outlined: "",
                                              role: "textbox",
                                              label: "Name",
                                              dense: "",
                                              "min-height": 30,
                                              rules: [_vm.alertRules.required],
                                            },
                                            on: { keypress: _vm.keyPressed },
                                            model: {
                                              value: _vm.newAlert.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newAlert,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "newAlert.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "dense-textarea",
                                            attrs: {
                                              outlined: "",
                                              role: "textbox",
                                              label: "Description",
                                              dense: "",
                                              "min-height": 30,
                                            },
                                            model: {
                                              value: _vm.newAlert.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newAlert,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newAlert.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        justify: _vm.$vuetify.breakpoint.xsOnly
                                          ? "center"
                                          : "start",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              "menu-props": {
                                                offsetY: true,
                                                maxHeight: "250",
                                              },
                                              outlined: "",
                                              dense: "",
                                              color: "primary",
                                              items: _vm.alertTypes,
                                              "item-text": "name",
                                              "return-object": "",
                                              label: "Choose Alert Type",
                                              rules: [
                                                _vm.alertRules.requiredObject,
                                              ],
                                            },
                                            on: {
                                              change: function ($event) {
                                                _vm.newAlert.name.length &&
                                                _vm.newAlert.sourceIds.length
                                                  ? _vm.wizardContinue()
                                                  : () => {}
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "item",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          " "
                                                      ),
                                                      _c("v-spacer"),
                                                      _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            "content-class":
                                                              "opaque-tooltip",
                                                            bottom: "",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-icon",
                                                                      _vm._g(
                                                                        {},
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          "far fa-question-circle"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.description
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2212523742
                                            ),
                                            model: {
                                              value: _vm.selectedAlertType,
                                              callback: function ($$v) {
                                                _vm.selectedAlertType = $$v
                                              },
                                              expression: "selectedAlertType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "py-0",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              multiple: "",
                                              "menu-props": {
                                                offsetY: true,
                                                maxHeight: "250",
                                              },
                                              outlined: "",
                                              dense: "",
                                              color: "primary",
                                              items: _vm.availableServers,
                                              "item-text": "name",
                                              "item-value": "id",
                                              label: "Choose Servers",
                                              "persistent-hint": "",
                                              rules: [
                                                _vm.alertRules.requiredServer,
                                              ],
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend-item",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          staticStyle: {
                                                            "max-height":
                                                              "40px",
                                                            "border-bottom":
                                                              "1px solid #7f7f7f",
                                                          },
                                                          attrs: { ripple: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectAllServers(
                                                                "newAlert"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  class:
                                                                    _vm.newAlert
                                                                      .sourceIds
                                                                      .length ===
                                                                    _vm
                                                                      .availableServers
                                                                      .length
                                                                      ? "primary--text"
                                                                      : _vm
                                                                          .$vuetify
                                                                          .theme
                                                                          .dark
                                                                      ? "white--text"
                                                                      : "black--text",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "16px !important",
                                                                    "font-weight":
                                                                      "400",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .newAlert
                                                                          ?.sourceIds
                                                                          ?.length ===
                                                                          _vm
                                                                            .availableServers
                                                                            ?.length
                                                                          ? "Deselect All"
                                                                          : "Select All"
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "item",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          " "
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function ({
                                                    item,
                                                    index,
                                                  }) {
                                                    return [
                                                      index === 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              class: {
                                                                "v-select-char-lim":
                                                                  _vm.newAlert
                                                                    .sourceIds
                                                                    .length > 1,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      index === 1
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " (+" +
                                                                _vm._s(
                                                                  _vm.newAlert
                                                                    .sourceIds
                                                                    .length - 1
                                                                ) +
                                                                " others) "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2175510953
                                            ),
                                            model: {
                                              value: _vm.newAlert.sourceIds,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newAlert,
                                                  "sourceIds",
                                                  $$v
                                                )
                                              },
                                              expression: "newAlert.sourceIds",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-step",
                            { attrs: { complete: _vm.wizard > 2, step: "2" } },
                            [_vm._v("Settings ")]
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "2" } },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "TWForm2",
                                  model: {
                                    value: _vm.validForm2,
                                    callback: function ($$v) {
                                      _vm.validForm2 = $$v
                                    },
                                    expression: "validForm2",
                                  },
                                },
                                [
                                  _vm.selectedAlertType.arguments &&
                                  _vm.wizard > 1
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.selectedAlertType.arguments,
                                          function (alertTypeArgument, i) {
                                            return _c(
                                              "div",
                                              { key: i },
                                              [
                                                _c(
                                                  "v-row",
                                                  {
                                                    attrs: {
                                                      justify: "space-between",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "pb-0 pl-5",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              alertTypeArgument.friendlyName
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              alertTypeArgument.metricUnit
                                                                ? "(" +
                                                                    alertTypeArgument.metricUnit +
                                                                    ")"
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    (alertTypeArgument.type ===
                                                      "double" ||
                                                      alertTypeArgument.type ===
                                                        "number") &&
                                                    !alertTypeArgument.plainValueOnly &&
                                                    !!_vm.newAlert.arguments
                                                      ? _c("v-checkbox", {
                                                          staticClass:
                                                            "pb-2 pr-5 small-checkbox",
                                                          staticStyle: {
                                                            "font-size":
                                                              "8px !important",
                                                          },
                                                          attrs: {
                                                            small: "",
                                                            dense: "",
                                                            label:
                                                              "Other value",
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.updateVue,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.newAlert
                                                                .arguments[
                                                                alertTypeArgument
                                                                  .name
                                                              ].customValue,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.newAlert
                                                                  .arguments[
                                                                  alertTypeArgument
                                                                    .name
                                                                ],
                                                                "customValue",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "\n                        newAlert.arguments[alertTypeArgument.name].customValue\n                      ",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                !!_vm.newAlert.arguments &&
                                                (_vm.newAlert.arguments[
                                                  alertTypeArgument.name
                                                ].customValue ||
                                                  alertTypeArgument.plainValueOnly)
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "pl-5",
                                                        staticStyle: {
                                                          "margin-top": "-12px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "py-0 pl-5",
                                                            attrs: {
                                                              cols: "11",
                                                              sm: "6",
                                                            },
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                outlined: "",
                                                                dense: "",
                                                                type: "number",
                                                                rules:
                                                                  _vm.constructRules(
                                                                    _vm.newAlert
                                                                      .arguments[
                                                                      alertTypeArgument
                                                                        .name
                                                                    ].value,
                                                                    alertTypeArgument.min,
                                                                    alertTypeArgument.max,
                                                                    true
                                                                  ),
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newAlert
                                                                    .arguments[
                                                                    alertTypeArgument
                                                                      .name
                                                                  ].value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .newAlert
                                                                        .arguments[
                                                                        alertTypeArgument
                                                                          .name
                                                                      ],
                                                                      "value",
                                                                      _vm._n(
                                                                        $$v
                                                                      )
                                                                    )
                                                                  },
                                                                expression:
                                                                  "\n                          newAlert.arguments[alertTypeArgument.name].value\n                        ",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : alertTypeArgument.type ===
                                                      "double" ||
                                                    alertTypeArgument.type ===
                                                      "number"
                                                  ? _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "pl-5",
                                                        staticStyle: {
                                                          "margin-top": "-12px",
                                                        },
                                                      },
                                                      [
                                                        alertTypeArgument.max !==
                                                          null &&
                                                        !!alertTypeArgument.step
                                                          ? _c("v-slider", {
                                                              staticClass:
                                                                "px-5",
                                                              class:
                                                                alertTypeArgument.max /
                                                                  alertTypeArgument.step >
                                                                100
                                                                  ? "slider-ticks-many"
                                                                  : "slider-ticks-few",
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                                margin: "auto",
                                                              },
                                                              attrs: {
                                                                min:
                                                                  Number(
                                                                    alertTypeArgument.min
                                                                  ) || 0,
                                                                max: Number(
                                                                  alertTypeArgument.max
                                                                ),
                                                                ticks: "always",
                                                                "tick-size":
                                                                  "2",
                                                                step: Number(
                                                                  alertTypeArgument.step
                                                                ),
                                                                "thumb-label":
                                                                  "always",
                                                                rules:
                                                                  _vm.constructRules(
                                                                    _vm.newAlert
                                                                      .arguments[
                                                                      alertTypeArgument
                                                                        .name
                                                                    ].value,
                                                                    alertTypeArgument.min,
                                                                    alertTypeArgument.max,
                                                                    false
                                                                  ),
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "thumb-label",
                                                                      fn: function ({
                                                                        value,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "pt-1 ec-slider",
                                                                              style:
                                                                                _vm.sliderStyle(
                                                                                  _vm
                                                                                    .newAlert
                                                                                    .arguments[
                                                                                    alertTypeArgument
                                                                                      .name
                                                                                  ]
                                                                                    .value
                                                                                ),
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    value
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                              model: {
                                                                value:
                                                                  _vm.newAlert
                                                                    .arguments[
                                                                    alertTypeArgument
                                                                      .name
                                                                  ].value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .newAlert
                                                                        .arguments[
                                                                        alertTypeArgument
                                                                          .name
                                                                      ],
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "newAlert.arguments[alertTypeArgument.name].value",
                                                              },
                                                            })
                                                          : _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "py-0 pl-5",
                                                                attrs: {
                                                                  cols: "11",
                                                                  sm: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      type: "number",
                                                                      rules:
                                                                        _vm.constructRules(
                                                                          _vm
                                                                            .newAlert
                                                                            .arguments[
                                                                            alertTypeArgument
                                                                              .name
                                                                          ]
                                                                            .value,
                                                                          alertTypeArgument.min,
                                                                          alertTypeArgument.max,
                                                                          true
                                                                        ),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .newAlert
                                                                          .arguments[
                                                                          alertTypeArgument
                                                                            .name
                                                                        ].value,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .newAlert
                                                                              .arguments[
                                                                              alertTypeArgument
                                                                                .name
                                                                            ],
                                                                            "value",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "\n                          newAlert.arguments[alertTypeArgument.name].value\n                        ",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ],
                                                      1
                                                    )
                                                  : alertTypeArgument.type ===
                                                    "boolean"
                                                  ? _c(
                                                      "v-row",
                                                      { staticClass: "pl-5" },
                                                      [
                                                        !!_vm.newAlert
                                                          .arguments[
                                                          alertTypeArgument.name
                                                        ]
                                                          ? _c("v-checkbox", {
                                                              staticClass:
                                                                "pb-2 pr-5 small-checkbox",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "8px !important",
                                                              },
                                                              attrs: {
                                                                small: "",
                                                                dense: "",
                                                                label:
                                                                  "Yes / No",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.updateVue,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.newAlert
                                                                    .arguments[
                                                                    alertTypeArgument
                                                                      .name
                                                                  ].value,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .newAlert
                                                                        .arguments[
                                                                        alertTypeArgument
                                                                          .name
                                                                      ],
                                                                      "value",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "\n                        newAlert.arguments[alertTypeArgument.name].value\n                      ",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-row",
                                                      { staticClass: "pl-5" },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pl-5",
                                                            attrs: {
                                                              cols: "11",
                                                              sm: "6",
                                                            },
                                                          },
                                                          [
                                                            !!_vm.newAlert
                                                              .arguments[
                                                              alertTypeArgument
                                                                .name
                                                            ]
                                                              ? _c(
                                                                  "v-textarea",
                                                                  {
                                                                    staticClass:
                                                                      "dense-textarea",
                                                                    attrs: {
                                                                      outlined:
                                                                        "",
                                                                      role: "textbox",
                                                                      placeholder:
                                                                        "...",
                                                                      dense: "",
                                                                      "min-height": 30,
                                                                      rules:
                                                                        alertTypeArgument.type ===
                                                                        "array (number)"
                                                                          ? [
                                                                              _vm
                                                                                .alertRules
                                                                                .containNumber,
                                                                            ]
                                                                          : [
                                                                              _vm
                                                                                .alertRules
                                                                                .required,
                                                                            ],
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .newAlert
                                                                          .arguments[
                                                                          alertTypeArgument
                                                                            .name
                                                                        ].value,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .newAlert
                                                                              .arguments[
                                                                              alertTypeArgument
                                                                                .name
                                                                            ],
                                                                            "value",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "\n                          newAlert.arguments[alertTypeArgument.name].value\n                        ",
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-stepper-step",
                            { attrs: { complete: _vm.wizard > 3, step: "3" } },
                            [_vm._v("Importance & Timing ")]
                          ),
                          _c(
                            "v-stepper-content",
                            { attrs: { step: "3" } },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "TWForm3",
                                  model: {
                                    value: _vm.validForm3,
                                    callback: function ($$v) {
                                      _vm.validForm3 = $$v
                                    },
                                    expression: "validForm3",
                                  },
                                },
                                [
                                  _c("p", [_vm._v("Notification Type")]),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pl-5 mt-2 mb-4",
                                      staticStyle: { "margin-top": "-26px" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "11", sm: "6" } },
                                        [
                                          _c("specifications", {
                                            ref: "specificationsPanel",
                                            attrs: {
                                              type: _vm.newAlert
                                                .notificationType,
                                              options: _vm.alertImportance,
                                            },
                                            on: {
                                              "change-type":
                                                _vm.changeNotificationTypeHandler,
                                              "change-settings":
                                                _vm.changeNotificationSettingsHandler,
                                            },
                                            model: {
                                              value:
                                                _vm.newAlert.specifications
                                                  .dynamicThreshold,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newAlert.specifications,
                                                  "dynamicThreshold",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "newAlert.specifications.dynamicThreshold",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("p", [_vm._v("Alert Timing")]),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "pr-11 text-center",
                                      staticStyle: { "font-size": "16px" },
                                    },
                                    [
                                      _vm._v(
                                        " Select Days (" +
                                          _vm._s(
                                            Object.keys(
                                              _vm.newAlert.daysOfWeek
                                            ).filter(
                                              (el) =>
                                                _vm.newAlert.daysOfWeek[el]
                                                  .value
                                            ).length
                                          ) +
                                          ") "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticClass: "days-of-week" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mr-7",
                                              attrs: { justify: "center" },
                                            },
                                            _vm._l(
                                              Object.keys(
                                                _vm.newAlert.daysOfWeek
                                              ),
                                              function (day) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: day,
                                                    staticClass: "days-wrap",
                                                  },
                                                  [
                                                    _c("v-btn", {
                                                      staticClass:
                                                        "one-color day",
                                                      class: _vm.newAlert
                                                        .daysOfWeek[day].value
                                                        ? "selected-day"
                                                        : "supplementary-class",
                                                      attrs: {
                                                        text: "",
                                                        color: "white",
                                                        "hide-details": "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectDay(
                                                            day
                                                          )
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "block",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            day
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm.newAlert
                                                                      .daysOfWeek[
                                                                      day
                                                                    ]
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "gray !important",
                                                                                "font-size":
                                                                                  "11px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.getDayTime(
                                                                                  day
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.newAlert
                                                            .daysOfWeek[day]
                                                            .value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.newAlert
                                                              .daysOfWeek[day],
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "newAlert.daysOfWeek[day].value",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center day-edit-wrapper",
                                                        class: _vm.newAlert
                                                          .daysOfWeek[day].value
                                                          ? "selected-day"
                                                          : "supplementary-class",
                                                        staticStyle: {
                                                          width: "68px",
                                                          height: "20px",
                                                          "padding-bottom":
                                                            "25px",
                                                          "margin-top": "-5px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            class: {
                                                              "selected-day":
                                                                _vm.newAlert
                                                                  .daysOfWeek[
                                                                  day
                                                                ].value,
                                                            },
                                                            attrs: {
                                                              dense: "",
                                                              "x-small": "",
                                                              width: "22",
                                                              height: "22",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.currentDayEditing =
                                                                  day
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "14px",
                                                                  "margin-left":
                                                                    "1px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "far fa-clock "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pt-5",
                                      staticStyle: { "margin-right": "32px" },
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "-10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.daysOfWeek[
                                                  _vm.currentDayEditing
                                                ]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.newAlert.daysOfWeek[
                                    this.currentDayEditing
                                  ]
                                    ? _c(
                                        "v-row",
                                        {
                                          staticClass: "mr-8",
                                          attrs: { justify: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pt-6 px-0",
                                              style: !_vm.$vuetify.breakpoint
                                                .xsOnly
                                                ? "margin-left:12px;height:76px;width:40px;text-align:center;"
                                                : "height:40px;width:40px;text-align:center;",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "mb-5",
                                                  staticStyle: {
                                                    position: "relative",
                                                    top: "35%",
                                                  },
                                                },
                                                [_vm._v(" From ")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "11", sm: "4" } },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  attrs: {
                                                    justify: "center",
                                                    align: "center",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minHour,
                                                      max: _vm.maxHour,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "from",
                                                          "hours"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.fromHour,
                                                      callback: function ($$v) {
                                                        _vm.fromHour =
                                                          _vm._n($$v)
                                                      },
                                                      expression: "fromHour",
                                                    },
                                                  }),
                                                  _vm._v(" : "),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minMinute,
                                                      max: _vm.maxMinute,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "from",
                                                          "minutes"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.fromMinute,
                                                      callback: function ($$v) {
                                                        _vm.fromMinute = $$v
                                                      },
                                                      expression: "fromMinute",
                                                    },
                                                  }),
                                                  _c("v-select", {
                                                    staticClass: "dayPeriods",
                                                    staticStyle: {
                                                      "max-width":
                                                        "35px !important",
                                                      "margin-left": "4px",
                                                    },
                                                    attrs: {
                                                      items: _vm.dayPeriods,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newAlert.daysOfWeek[
                                                          _vm.currentDayEditing
                                                        ].time.from.dayPeriod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.newAlert
                                                            .daysOfWeek[
                                                            _vm
                                                              .currentDayEditing
                                                          ].time.from,
                                                          "dayPeriod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                        newAlert.daysOfWeek[currentDayEditing].time.from\n                          .dayPeriod\n                      ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          !_vm.$vuetify.breakpoint.xsOnly
                                            ? _c(
                                                "v-col",
                                                {
                                                  staticStyle: {
                                                    height: "76px",
                                                    width: "20px",
                                                    "text-align": "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticStyle: {
                                                        position: "relative",
                                                        top: "50%",
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "v-col",
                                            {
                                              style: !_vm.$vuetify.breakpoint
                                                .xsOnly
                                                ? "height:76px;width:40px;text-align:center;"
                                                : "height:40px;width:40px;text-align:center;",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    position: "relative",
                                                    top: "50%",
                                                  },
                                                },
                                                [_vm._v("To")]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0 pt-3",
                                              staticStyle: {
                                                height: "76px !important",
                                              },
                                              attrs: { cols: "11", sm: "4" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    justify: "center",
                                                    align: "center",
                                                  },
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minHour,
                                                      max: _vm.maxHour,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "to",
                                                          "hours"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.toHour,
                                                      callback: function ($$v) {
                                                        _vm.toHour = $$v
                                                      },
                                                      expression: "toHour",
                                                    },
                                                  }),
                                                  _vm._v(" : "),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minMinute,
                                                      max: _vm.maxMinute,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "to",
                                                          "minutes"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.toMinute,
                                                      callback: function ($$v) {
                                                        _vm.toMinute = $$v
                                                      },
                                                      expression: "toMinute",
                                                    },
                                                  }),
                                                  _c("v-select", {
                                                    staticClass: "dayPeriods",
                                                    staticStyle: {
                                                      "max-width":
                                                        "35px !important",
                                                      "margin-left": "4px",
                                                    },
                                                    attrs: {
                                                      items: _vm.dayPeriods,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.newAlert.daysOfWeek[
                                                          _vm.currentDayEditing
                                                        ].time.to.dayPeriod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.newAlert
                                                            .daysOfWeek[
                                                            _vm
                                                              .currentDayEditing
                                                          ].time.to,
                                                          "dayPeriod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                        newAlert.daysOfWeek[currentDayEditing].time.to\n                          .dayPeriod\n                      ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      style: `max-height: ${
                        _vm.$vuetify.breakpoint.height - 270
                      }px; overflow-y:auto;overflow-x:hidden;`,
                      attrs: { id: "top-scrolls" },
                    },
                    [
                      _vm.currentEditIssue.arguments
                        ? _c(
                            "div",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "TWEditForm",
                                  staticClass: "pt-2",
                                  model: {
                                    value: _vm.editValidForm,
                                    callback: function ($$v) {
                                      _vm.editValidForm = $$v
                                    },
                                    expression: "editValidForm",
                                  },
                                },
                                [
                                  _c("v-row", { staticClass: "mx-0" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "pb-0 pl-5 alert-editor-label",
                                      },
                                      [_vm._v("Name")]
                                    ),
                                  ]),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      class: _vm.getTextFieldPadding,
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 pt-1",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "dense-textarea",
                                            attrs: {
                                              outlined: "",
                                              role: "textbox",
                                              placeholder: "...",
                                              dense: "",
                                              "min-height": 30,
                                              rules: [_vm.alertRules.required],
                                            },
                                            model: {
                                              value: _vm.currentEditIssue.name,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentEditIssue,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentEditIssue.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-row", { staticClass: "mx-0" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "pb-0 pl-5 alert-editor-label",
                                      },
                                      [_vm._v("Description")]
                                    ),
                                  ]),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0 mt-2",
                                      class: _vm.getTextFieldPadding,
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 pt-1",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "dense-textarea",
                                            attrs: {
                                              outlined: "",
                                              role: "textbox",
                                              placeholder: "...",
                                              dense: "",
                                              "min-height": 30,
                                            },
                                            model: {
                                              value:
                                                _vm.currentEditIssue
                                                  .description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentEditIssue,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentEditIssue.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-row", { staticClass: "mx-0" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "pb-0 pl-5 alert-editor-label",
                                      },
                                      [_vm._v("Sources")]
                                    ),
                                  ]),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0",
                                      class: _vm.getTextFieldPadding,
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 pt-1 mt-2",
                                          attrs: { cols: "11", sm: "6" },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              multiple: "",
                                              "menu-props": {
                                                offsetY: true,
                                                maxHeight: "250",
                                              },
                                              outlined: "",
                                              dense: "",
                                              color: "primary",
                                              items: _vm.availableServers,
                                              "item-text": "name",
                                              "item-value": "id",
                                              label: "Choose Servers",
                                              "persistent-hint": "",
                                              rules: [
                                                _vm.alertRules.requiredServer,
                                              ],
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "prepend-item",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          staticStyle: {
                                                            "max-height":
                                                              "40px",
                                                            "border-bottom":
                                                              "1px solid #7f7f7f",
                                                          },
                                                          attrs: { ripple: "" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.selectAllServers(
                                                                "currentEditIssue"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  class:
                                                                    _vm
                                                                      .currentEditIssue
                                                                      .sourceIds
                                                                      .length ===
                                                                    _vm
                                                                      .availableServers
                                                                      .length
                                                                      ? "primary--text"
                                                                      : _vm
                                                                          .$vuetify
                                                                          .theme
                                                                          .dark
                                                                      ? "white--text"
                                                                      : "black--text",
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "16px !important",
                                                                    "font-weight":
                                                                      "400",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .currentEditIssue
                                                                          ?.sourceIds
                                                                          ?.length ===
                                                                          _vm
                                                                            .availableServers
                                                                            ?.length
                                                                          ? "Deselect All"
                                                                          : "Select All"
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                                {
                                                  key: "item",
                                                  fn: function ({ item }) {
                                                    return [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          " "
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: "selection",
                                                  fn: function ({
                                                    item,
                                                    index,
                                                  }) {
                                                    return [
                                                      index === 0
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              class: {
                                                                "v-select-char-lim":
                                                                  _vm
                                                                    .currentEditIssue
                                                                    .sourceIds
                                                                    .length > 1,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      index === 1
                                                        ? _c("span", [
                                                            _vm._v(
                                                              " (+" +
                                                                _vm._s(
                                                                  _vm
                                                                    .currentEditIssue
                                                                    .sourceIds
                                                                    .length - 1
                                                                ) +
                                                                " others) "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1451235869
                                            ),
                                            model: {
                                              value:
                                                _vm.currentEditIssue.sourceIds,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.currentEditIssue,
                                                  "sourceIds",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "currentEditIssue.sourceIds",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    _vm.getAlertSettingsNames,
                                    function (setting) {
                                      return _c(
                                        "div",
                                        { key: setting },
                                        [
                                          !!_vm.currentEditIssue.alertType &&
                                          !!setting
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    justify: "space-between",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "pb-0 pl-5 alert-editor-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.currentEditIssue.alertType.arguments[
                                                              setting
                                                            ].friendlyName.split(
                                                              "_"
                                                            ).length > 1
                                                              ? _vm.currentEditIssue.alertType.arguments[
                                                                  setting
                                                                ].friendlyName.split(
                                                                  "_"
                                                                )[0] +
                                                                  " " +
                                                                  _vm.currentEditIssue.alertType.arguments[
                                                                    setting
                                                                  ].friendlyName.split(
                                                                    "_"
                                                                  )[1]
                                                              : _vm.currentEditIssue.alertType.arguments[
                                                                  setting
                                                                ].friendlyName.split(
                                                                  "_"
                                                                )[0]
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.currentEditIssue
                                                              .alertType
                                                              .arguments[
                                                              setting
                                                            ].metricUnit
                                                              ? "(" +
                                                                  _vm
                                                                    .currentEditIssue
                                                                    .alertType
                                                                    .arguments[
                                                                    setting
                                                                  ].metricUnit +
                                                                  ")"
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  (_vm.currentEditIssue
                                                    .alertType.arguments[
                                                    setting
                                                  ].type === "double" ||
                                                    _vm.currentEditIssue
                                                      .alertType.arguments[
                                                      setting
                                                    ].type === "number") &&
                                                  !_vm.currentEditIssue
                                                    .alertType.arguments[
                                                    setting
                                                  ].plainValueOnly
                                                    ? _c("v-checkbox", {
                                                        staticClass:
                                                          "pb-2 pr-5 small-checkbox",
                                                        staticStyle: {
                                                          "font-size":
                                                            "8px !important",
                                                        },
                                                        attrs: {
                                                          small: "",
                                                          dense: "",
                                                          label: "Other value",
                                                        },
                                                        on: {
                                                          change: _vm.updateVue,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.currentEditIssue
                                                              .arguments[
                                                              setting
                                                            ].customValue,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm
                                                                .currentEditIssue
                                                                .arguments[
                                                                setting
                                                              ],
                                                              "customValue",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "currentEditIssue.arguments[setting].customValue",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.currentEditIssue.arguments[
                                            setting
                                          ].customValue ||
                                          _vm.currentEditIssue.alertType
                                            .arguments[setting].plainValueOnly
                                            ? [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "mx-0",
                                                    class:
                                                      _vm.getTextFieldPadding,
                                                    staticStyle: {
                                                      "margin-top": "-12px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "py-0 mt-4",
                                                        attrs: {
                                                          cols: "11",
                                                          sm: "6",
                                                        },
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            outlined: "",
                                                            dense: "",
                                                            type: "number",
                                                            rules:
                                                              _vm.constructRules(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .arguments[
                                                                  setting
                                                                ].value,
                                                                _vm
                                                                  .currentEditIssue
                                                                  .alertType
                                                                  .arguments[
                                                                  setting
                                                                ].min,
                                                                _vm
                                                                  .currentEditIssue
                                                                  .alertType
                                                                  .arguments[
                                                                  setting
                                                                ].max,
                                                                true
                                                              ),
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .currentEditIssue
                                                                .arguments[
                                                                setting
                                                              ].value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .arguments[
                                                                  setting
                                                                ],
                                                                "value",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "currentEditIssue.arguments[setting].value",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm.currentEditIssue.alertType
                                                .arguments[setting].type ===
                                                "double" ||
                                              _vm.currentEditIssue.alertType
                                                .arguments[setting].type ===
                                                "number"
                                            ? [
                                                Number(
                                                  _vm.currentEditIssue.alertType
                                                    .arguments[setting].step
                                                ) > 0 &&
                                                Number(
                                                  _vm.currentEditIssue.alertType
                                                    .arguments[setting].max
                                                ) > 0
                                                  ? _c(
                                                      "v-row",
                                                      [
                                                        _c("v-slider", {
                                                          class: [
                                                            _vm.currentEditIssue
                                                              .alertType
                                                              .arguments[
                                                              setting
                                                            ].max /
                                                              _vm
                                                                .currentEditIssue
                                                                .alertType
                                                                .arguments[
                                                                setting
                                                              ].step >
                                                            100
                                                              ? "slider-ticks-many"
                                                              : "slider-ticks-few",
                                                            _vm.getSlidersPadding,
                                                          ],
                                                          staticStyle: {
                                                            "text-align":
                                                              "center",
                                                            margin: "auto",
                                                          },
                                                          attrs: {
                                                            min:
                                                              Number(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .alertType
                                                                  .arguments[
                                                                  setting
                                                                ].min
                                                              ) || 0,
                                                            max: Number(
                                                              _vm
                                                                .currentEditIssue
                                                                .alertType
                                                                .arguments[
                                                                setting
                                                              ].max
                                                            ),
                                                            ticks: "always",
                                                            step: Number(
                                                              _vm
                                                                .currentEditIssue
                                                                .alertType
                                                                .arguments[
                                                                setting
                                                              ].step
                                                            ),
                                                            "thumb-label":
                                                              "always",
                                                            rules:
                                                              _vm.constructRules(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .arguments[
                                                                  setting
                                                                ].value,
                                                                _vm
                                                                  .currentEditIssue
                                                                  .alertType
                                                                  .arguments[
                                                                  setting
                                                                ].min,
                                                                _vm
                                                                  .currentEditIssue
                                                                  .alertType
                                                                  .arguments[
                                                                  setting
                                                                ].max,
                                                                false
                                                              ),
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "thumb-label",
                                                                fn: function ({
                                                                  value,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "pt-1 ec-slider",
                                                                        style:
                                                                          _vm.sliderStyle(
                                                                            value
                                                                          ),
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              value
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                          model: {
                                                            value:
                                                              _vm
                                                                .currentEditIssue
                                                                .arguments[
                                                                setting
                                                              ].value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .arguments[
                                                                  setting
                                                                ],
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentEditIssue.arguments[setting].value",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            staticClass: "mx-0",
                                                            class:
                                                              _vm.getTextFieldPadding,
                                                            staticStyle: {
                                                              "margin-top":
                                                                "-12px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "py-0",
                                                                attrs: {
                                                                  cols: "11",
                                                                  sm: "6",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      type: "number",
                                                                      rules:
                                                                        _vm.constructRules(
                                                                          _vm
                                                                            .currentEditIssue
                                                                            .arguments[
                                                                            setting
                                                                          ]
                                                                            .value,
                                                                          _vm
                                                                            .currentEditIssue
                                                                            .alertType
                                                                            .arguments[
                                                                            setting
                                                                          ].min,
                                                                          _vm
                                                                            .currentEditIssue
                                                                            .alertType
                                                                            .arguments[
                                                                            setting
                                                                          ].max,
                                                                          true
                                                                        ),
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .currentEditIssue
                                                                          .arguments[
                                                                          setting
                                                                        ].value,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .currentEditIssue
                                                                              .arguments[
                                                                              setting
                                                                            ],
                                                                            "value",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "currentEditIssue.arguments[setting].value",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ]
                                            : _vm.currentEditIssue.alertType
                                                .arguments[setting].type ===
                                              "boolean"
                                            ? [
                                                _c(
                                                  "v-row",
                                                  {
                                                    staticClass: "mx-0",
                                                    class:
                                                      _vm.getTextFieldPadding,
                                                  },
                                                  [
                                                    _c("v-checkbox", {
                                                      staticClass:
                                                        "pb-2 pr-5 small-checkbox",
                                                      staticStyle: {
                                                        "font-size":
                                                          "8px !important",
                                                      },
                                                      attrs: {
                                                        small: "",
                                                        dense: "",
                                                        label: "Yes / No",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.currentEditIssue
                                                            .arguments[setting]
                                                            .value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.currentEditIssue
                                                              .arguments[
                                                              setting
                                                            ],
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "currentEditIssue.arguments[setting].value",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : [
                                                _c(
                                                  "v-row",
                                                  { staticClass: "pl-15 mx-0" },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          cols: "11",
                                                          sm: "6",
                                                        },
                                                      },
                                                      [
                                                        _c("v-textarea", {
                                                          staticClass:
                                                            "dense-textarea",
                                                          attrs: {
                                                            outlined: "",
                                                            role: "textbox",
                                                            placeholder: "...",
                                                            dense: "",
                                                            "min-height": 30,
                                                            rules:
                                                              _vm
                                                                .currentEditIssue
                                                                .alertType
                                                                .arguments[
                                                                setting
                                                              ].type ===
                                                              "array (number)"
                                                                ? [
                                                                    _vm
                                                                      .alertRules
                                                                      .containNumber,
                                                                  ]
                                                                : [
                                                                    _vm
                                                                      .alertRules
                                                                      .required,
                                                                  ],
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .currentEditIssue
                                                                .arguments[
                                                                setting
                                                              ].value,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .currentEditIssue
                                                                  .arguments[
                                                                  setting
                                                                ],
                                                                "value",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "currentEditIssue.arguments[setting].value",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _c(
                                    "p",
                                    { staticClass: "pl-5 alert-editor-label" },
                                    [_vm._v("Notification")]
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mx-0 mt-2",
                                      class: _vm.$vuetify.breakpoint.smAndUp
                                        ? "pl-15"
                                        : "pl-10",
                                    },
                                    [
                                      _c("specifications", {
                                        attrs: {
                                          type: _vm.currentEditIssue
                                            .notificationType,
                                          options: _vm.alertImportance,
                                        },
                                        on: {
                                          "change-type":
                                            _vm.changeNotificationTypeHandler,
                                          "change-settings":
                                            _vm.changeNotificationSettingsHandler,
                                        },
                                        model: {
                                          value:
                                            _vm.currentEditIssue.specifications
                                              .dynamicThreshold,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.currentEditIssue
                                                .specifications,
                                              "dynamicThreshold",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "currentEditIssue.specifications.dynamicThreshold",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-center mx-0 alert-editor-label",
                                      staticStyle: { "font-size": "16px" },
                                    },
                                    [
                                      _vm._v(
                                        " Select Days (" +
                                          _vm._s(
                                            Object.keys(
                                              _vm.currentEditIssue.daysOfWeek
                                            ).filter(
                                              (el) =>
                                                _vm.currentEditIssue.daysOfWeek[
                                                  el
                                                ].value
                                            ).length
                                          ) +
                                          ") "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-row",
                                    { staticClass: "days-of-week mx-0" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            _vm._l(
                                              Object.keys(
                                                _vm.currentEditIssue.daysOfWeek
                                              ),
                                              function (day) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: day,
                                                    staticClass: "days-wrap",
                                                  },
                                                  [
                                                    _c("v-btn", {
                                                      key: _vm.daysSelectorRenderKey,
                                                      staticClass:
                                                        "one-color day",
                                                      class: _vm
                                                        .currentEditIssue
                                                        .daysOfWeek[day].value
                                                        ? "selected-day"
                                                        : "supplementary-class",
                                                      attrs: {
                                                        text: "",
                                                        color: "primary",
                                                        "hide-details": "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.selectDayOfWeekEditing(
                                                            day
                                                          )
                                                        },
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        class: {
                                                                          "black--text":
                                                                            !_vm
                                                                              .$vuetify
                                                                              .theme
                                                                              .dark,
                                                                        },
                                                                        staticStyle:
                                                                          {
                                                                            display:
                                                                              "block",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            day
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm
                                                                      .currentEditIssue
                                                                      .daysOfWeek[
                                                                      day
                                                                    ]
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            key: _vm.dayTimeRenderKey,
                                                                            staticStyle:
                                                                              {
                                                                                color:
                                                                                  "gray !important",
                                                                                "font-size":
                                                                                  "11px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.getDayTime(
                                                                                  day,
                                                                                  "currentEditIssue"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                      model: {
                                                        value:
                                                          _vm.currentEditIssue
                                                            .daysOfWeek[day]
                                                            .value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.currentEditIssue
                                                              .daysOfWeek[day],
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "currentEditIssue.daysOfWeek[day].value",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-center day-edit-wrapper",
                                                        class: _vm
                                                          .currentEditIssue
                                                          .daysOfWeek[day].value
                                                          ? "selected-day"
                                                          : "supplementary-class",
                                                        staticStyle: {
                                                          width: "68px",
                                                          height: "20px",
                                                          "padding-bottom":
                                                            "25px",
                                                          "margin-top": "-5px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            class: {
                                                              "selected-day":
                                                                _vm
                                                                  .currentEditIssue
                                                                  .daysOfWeek[
                                                                  day
                                                                ].value,
                                                            },
                                                            attrs: {
                                                              dense: "",
                                                              "x-small": "",
                                                              width: "22",
                                                              height: "22",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.editAlertTime(
                                                                  day
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "14px",
                                                                  "margin-left":
                                                                    "1px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "far fa-clock "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pt-5 mx-0",
                                      attrs: { justify: "center" },
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            "margin-bottom": "-10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.daysOfWeek[
                                                  _vm.currentDayEditing
                                                ]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.newAlert.daysOfWeek[
                                    this.currentDayEditing
                                  ]
                                    ? _c(
                                        "v-row",
                                        {
                                          staticClass: "mx-0",
                                          attrs: { justify: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              class: {
                                                "py-0":
                                                  _vm.$vuetify.breakpoint
                                                    .xsOnly,
                                              },
                                              staticStyle: { height: "50px" },
                                              attrs: { cols: "11", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  class: {
                                                    "pr-4":
                                                      _vm.$vuetify.breakpoint
                                                        .smAndUp,
                                                  },
                                                  attrs: {
                                                    id: "timing-wrapper",
                                                    justify: _vm.$vuetify
                                                      .breakpoint.xsOnly
                                                      ? "center"
                                                      : "end",
                                                    align: "center",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 mt-3 mr-5",
                                                      },
                                                      [_vm._v("From")]
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minHour,
                                                      max: _vm.maxHour,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "from",
                                                          "hours"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.fromHour,
                                                      callback: function ($$v) {
                                                        _vm.fromHour =
                                                          _vm._n($$v)
                                                      },
                                                      expression: "fromHour",
                                                    },
                                                  }),
                                                  _vm._v(" : "),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minMinute,
                                                      max: _vm.maxMinute,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "from",
                                                          "minutes"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.fromMinute,
                                                      callback: function ($$v) {
                                                        _vm.fromMinute = $$v
                                                      },
                                                      expression: "fromMinute",
                                                    },
                                                  }),
                                                  _c("v-select", {
                                                    staticClass: "dayPeriods",
                                                    staticStyle: {
                                                      "max-width":
                                                        "35px !important",
                                                      "margin-left": "4px",
                                                    },
                                                    attrs: {
                                                      items: _vm.dayPeriods,
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.rerenderDayTime,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentEditIssue
                                                          .daysOfWeek[
                                                          _vm.currentDayEditing
                                                        ].time.from.dayPeriod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.currentEditIssue
                                                            .daysOfWeek[
                                                            _vm
                                                              .currentDayEditing
                                                          ].time.from,
                                                          "dayPeriod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                      currentEditIssue.daysOfWeek[currentDayEditing].time.from\n                        .dayPeriod\n                    ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "pb-0",
                                              class: {
                                                "py-0":
                                                  _vm.$vuetify.breakpoint
                                                    .xsOnly,
                                              },
                                              staticStyle: { height: "50px" },
                                              attrs: { cols: "11", sm: "6" },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "mx-0",
                                                  class: {
                                                    "pr-4":
                                                      _vm.$vuetify.breakpoint
                                                        .smAndUp,
                                                  },
                                                  attrs: {
                                                    align: "center",
                                                    justify: _vm.$vuetify
                                                      .breakpoint.xsOnly
                                                      ? "center"
                                                      : "start",
                                                  },
                                                },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 mt-3 mr-5",
                                                      },
                                                      [_vm._v("To")]
                                                    ),
                                                  ]),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minHour,
                                                      max: _vm.maxHour,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "to",
                                                          "hours"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.toHour,
                                                      callback: function ($$v) {
                                                        _vm.toHour = $$v
                                                      },
                                                      expression: "toHour",
                                                    },
                                                  }),
                                                  _vm._v(" : "),
                                                  _c("v-text-field", {
                                                    staticClass:
                                                      "pt-0 my-0 no-underline align-center",
                                                    staticStyle: {
                                                      "max-width": "35px",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      type: "number",
                                                      min: _vm.minMinute,
                                                      max: _vm.maxMinute,
                                                      step: "1",
                                                      required: "",
                                                      "hide-details": "",
                                                    },
                                                    on: {
                                                      input: (value) =>
                                                        _vm.timeChanged(
                                                          value,
                                                          "to",
                                                          "minutes"
                                                        ),
                                                    },
                                                    model: {
                                                      value: _vm.toMinute,
                                                      callback: function ($$v) {
                                                        _vm.toMinute = $$v
                                                      },
                                                      expression: "toMinute",
                                                    },
                                                  }),
                                                  _c("v-select", {
                                                    staticClass: "dayPeriods",
                                                    staticStyle: {
                                                      "max-width":
                                                        "35px !important",
                                                      "margin-left": "4px",
                                                    },
                                                    attrs: {
                                                      items: _vm.dayPeriods,
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.rerenderDayTime,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentEditIssue
                                                          .daysOfWeek[
                                                          _vm.currentDayEditing
                                                        ].time.to.dayPeriod,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.currentEditIssue
                                                            .daysOfWeek[
                                                            _vm
                                                              .currentDayEditing
                                                          ].time.to,
                                                          "dayPeriod",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "\n                      currentEditIssue.daysOfWeek[currentDayEditing].time.to\n                        .dayPeriod\n                    ",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c("v-row", { staticClass: "mx-0" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "pb-0 pl-5 alert-editor-label",
                                      },
                                      [_vm._v("Subscription Groups")]
                                    ),
                                  ]),
                                  _c(
                                    "v-row",
                                    { staticClass: "mx-0" },
                                    [
                                      _c("subscription-groups", {
                                        attrs: {
                                          "alert-card": {
                                            id: _vm.currentEditIssue.id,
                                            name: _vm.currentEditIssue.name,
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
              _c(
                "v-row",
                {
                  staticClass: "mx-0 accent",
                  attrs: { justify: "space-between" },
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-2 opacity-1-slow",
                      attrs: { text: "" },
                      on: { click: _vm.closeAlertEditor },
                    },
                    [_vm._v("Cancel ")]
                  ),
                  !_vm.edit
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "my-2 opacity-1-slow",
                          attrs: { disabled: _vm.wizard === 1, text: "" },
                          on: { click: _vm.wizardBack },
                        },
                        [_vm._v("Back ")]
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _vm.wizard < 3 && !_vm.edit
                    ? _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              _vm.disableContinueWizard
                                ? _vm.validateForm()
                                : _vm.wizardContinue()
                            },
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2 opacity-1-slow",
                              attrs: {
                                disabled: _vm.disableContinueWizard,
                                color: "primary",
                              },
                            },
                            [_vm._v("continue ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          on: { mouseenter: _vm.checkSaveThresholdEligibility },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              class:
                                _vm.wizard < 3 && !_vm.edit
                                  ? "opacity-0"
                                  : "opacity-1-slow",
                              attrs: {
                                disabled:
                                  (!_vm.editValidForm && _vm.edit) ||
                                  (_vm.disableContinueWizard && !_vm.edit),
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.edit
                                    ? _vm.saveAlertCardEdit()
                                    : _vm.saveAlertCard()
                                },
                              },
                            },
                            [_vm._v("save ")]
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }